module.exports = __webpack_public_path__ + "img/tuceng22.d376392e.png";